import React from "react";
import "./loader.css";
import LoaderGif from "./loader.gif";

const ApiLoader = () => {
	return (
		<div className="fp-container">
			<div className="fp-loader">
				<img src={LoaderGif} alt="loading" />
			</div>
		</div>
	);
};

export default ApiLoader;
